"use client";

import { Facebook, Instagram, Linkedin, Phone, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-4 w-16 bg-muted-light animate-pulse rounded-sm" />
        <div className="h-4 w-16 bg-muted-light animate-pulse rounded-sm" />
        <div className="h-4 w-16 bg-muted-light animate-pulse rounded-sm" />
      </div>;
  }
  const allowedLabels = ["About", "Our Process", "Portfolio", "Contact"];
  const filteredItems = menuItems.filter(item => allowedLabels.includes(item.label));
  return <NavigationMenu viewport={false}>
      <NavigationMenuList>
        {filteredItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="relative text-sm font-medium text-foreground-dark transition-all duration-[150ms] ease-out hover:text-primary after:absolute after:bottom-0 after:left-0 after:h-px after:w-0 after:bg-primary after:transition-all after:duration-[150ms] after:ease-out hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }];
  const centralMaineTowns = ["Belgrade", "Manchester", "Litchfield", "Wayne", "and surrounding areas"];
  return <footer ref={ref} className={`w-full bg-dark-background py-12 transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-foreground-dark font-semibold mb-4">Quick Links</h3>
            <MenuProvider menu_id="13">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-foreground-dark font-semibold mb-4">Contact</h3>
            <div className="flex items-center gap-2 text-foreground-dark/80 mb-2">
              <Phone className="size-4" />
              <Link to="tel:+12075551234" className="text-sm hover:text-primary transition-colors duration-[150ms]">(207) 449-0509</Link>
            </div>
            <div className="flex items-start gap-2 text-foreground-dark/80">
              <MapPin className="size-4 mt-0.5" />
              <div className="text-sm">
                <p className="mb-1">Serving Central Maine:</p>
                <p className="text-foreground-dark/60">
                  {centralMaineTowns.join(", ")}
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-foreground-dark font-semibold mb-4">Follow Us</h3>
            <div className="flex items-center gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} newTab aria-label={social.label} data-index={i} className="text-foreground-dark hover:text-primary transition-colors duration-[150ms] ease-out">
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-dark/20 pt-6 text-center md:text-left">
          <p className="text-sm text-foreground-dark/70">
            © {new Date().getFullYear()} Brighthouse Construction. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}